var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 128L128 146L201 73L128 0L0 128L128 256L256 128L224 96L128 192L64 128L128 64L151 87L110 128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.24fb719a4bf622d96d2bcd53dc61d8e5.svg";
export { ForwardRef as ReactComponent };